  <!--Modal container-->
  <div class="eva-3-modal -no-padding map" *ngIf="wasOpened" CloseModalClick [modal]="this" [ngClass]="{'-show-modal': isOpen}">
    <div class="modal-header">
      <i class="modal-close eva-3-icon-close" (click)="close()"></i>
      <div class="modal-title-container">
        <h4 class="modal-title eva-3-h4 -eva-3-hide-small">{{ 'map-modal.selectedPoints' | translate }}</h4>
        <h4 class="modal-title eva-3-h4 -eva-3-hide-medium-up">{{ 'map-modal.mobile.title' | translate }}</h4>
      </div>
    </div>
    <div class="modal-content">
      <gmap [centerOnClick]="true" [disableUI]="true" [zoom]="8" [zoomControl]="true" [draggable]="true" [mapTypeControl]="false"  [points]="mapPoints">
      </gmap>
    </div>
  </div>